import { Rebates } from '../Rebates/Rebates'
import { CognusAR } from '../CognusAR/CognusAR'
import { SplitFeesContainer } from '../SplitFees/SplitFeesContainer'
import { Admin } from '../Admin/Admin'

export const FINANCIAL_ROUTES = [
  {
    path: '0',
    component: Rebates
  },
  {
    path: '1',
    component: Admin
  },
  {
    path: '2',
    component: CognusAR
  },
  {
    path: '3',
    component: SplitFeesContainer
  }
]
